export default "__VITE_ASSET__6751f6aa__"